import { useQuery } from "@tanstack/react-query";
import { plantService } from "../services/plant.service";
import type { PlantListParams } from "../types";

export const plantKeys = {
	all: ["plants"] as const,
	lists: () => [...plantKeys.all, "list"] as const,
	list: (params?: PlantListParams) => [...plantKeys.lists(), params] as const,
};

export function usePlantList(params?: PlantListParams) {
	return useQuery({
		queryKey: plantKeys.list(params),
		queryFn: () => plantService.list(params),
		// organizationId is required by backend; only fetch when present
		enabled: params?.organizationId === undefined ? true : !!params.organizationId,
	});
}
